import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PinOffIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M18.0001 2C18.5523 2 19 2.44767 19 2.9999C19 3.55213 18.5523 3.99981 18.0001 3.99981H17.3939V12.375L8.37374 3.375V2H18.0001ZM13.5556 22L12.596 21.2V13.9998H6.83838V11.9998C8.05051 11.8105 9.11416 11.0682 9.71717 9.99981L3.67367 4.0619C3.30033 3.69509 3.29152 3.0962 3.65391 2.71856C4.03004 2.32659 4.65683 2.32659 5.03296 2.71856L21.3329 19.7048C21.7038 20.0914 21.6985 20.7034 21.3208 21.0834C20.9302 21.4764 20.2927 21.4708 19.9091 21.071L14.2753 15.2L14.5152 15.45V21.2L13.5556 22Z'
                fill='currentColor'
            />
        </>
    ),
})

PinOffIcon.displayName = 'PinOffIcon'
